const CareersPathConstants = {
  CAREERS: '/Careers',
  INTERNS: '/Careers/interns',
  PROFESSIONALS: '/Careers/professionals',
};

export default CareersPathConstants;
